import { Component } from '@angular/core';

@Component({
  selector: 'app-cards11-examples-69',
  templateUrl: './cards11-examples-69.component.html'
})
export class Cards11Examples69Component {}
